// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"168":"63dfd009","187":"f7ac862f","892":"f22300bd"}[chunkId] + ".js";
};